export const api = {
  login: '/login',
  resetPassword: '/password/reset',
  reset: '/password/email',
  update: '/update',
  register: '/register',
  refreshOauthToken: '/refresh-token',
  logout: '/logout',
}
